import { Button } from '@mantine/core';
import { IconAlertOctagon } from '@tabler/icons-react';
import { appConfig } from '../lib/auth';

// INC-01: ссылка на канал инцидентов на каждой странице
export function IncidentLink({ compact = false }: { compact?: boolean }) {
  return (
    <Button component="a" href={appConfig().incidentUrl} target="_blank" rel="noopener noreferrer" variant="light" color="red" size="xs" leftSection={<IconAlertOctagon size={14} />}>
      {compact ? 'Инцидент' : 'Сообщить об инциденте'}
    </Button>
  );
}
